import PropTypes from 'prop-types';
import React from 'react';
import defaultDatasetLogo from 'images/default-dataset-logo.png';
import FallbackImage from 'components/FallbackImage';

const DataSourceLogo = ({provider, size, ...rest}) =>
  provider ? (
    <FallbackImage
      src={`/api/data/v1/providers/${provider}/images/${size}.png`}
      fallbackSrc={defaultDatasetLogo}
      {...rest}
    />
  ) : null;

DataSourceLogo.propTypes = {
  size: PropTypes.number.isRequired,
  provider: PropTypes.string,
};

DataSourceLogo.SIZES = {
  SMALL: 16,
  MEDIUM: 32,
  LARGE: 48,
};

DataSourceLogo.defaultProps = {
  size: DataSourceLogo.SIZES.LARGE,
};

export default DataSourceLogo;
